/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Scoring capability for a game
 * @export
 */
export const ScoringCapability = {
    AUTO_ONLY: 'AUTO_ONLY',
    MANUAL_ONLY: 'MANUAL_ONLY',
    BOTH: 'BOTH'
} as const;
export type ScoringCapability = typeof ScoringCapability[keyof typeof ScoringCapability];


export function instanceOfScoringCapability(value: any): boolean {
    for (const key in ScoringCapability) {
        if (Object.prototype.hasOwnProperty.call(ScoringCapability, key)) {
            if (ScoringCapability[key as keyof typeof ScoringCapability] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScoringCapabilityFromJSON(json: any): ScoringCapability {
    return ScoringCapabilityFromJSONTyped(json, false);
}

export function ScoringCapabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringCapability {
    return json as ScoringCapability;
}

export function ScoringCapabilityToJSON(value?: ScoringCapability | null): any {
    return value as any;
}

export function ScoringCapabilityToJSONTyped(value: any, ignoreDiscriminator: boolean): ScoringCapability {
    return value as ScoringCapability;
}

